class UserSystem {
    appleUser() {
        return /iPhone|iPad|Macintosh/i.test(navigator.userAgent);
    }

}

export default new UserSystem();